import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useForm } from 'react-hook-form';
import { Grid } from '@mui/material';
import { dropBoolean } from 'utils/drops';
import { GridContext } from 'contexts/GridContext';
import Container from 'components/Container';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';

const Manutenção = () => {
  const rotina = 'Tabpreco';
  const defaultValues = {
    descricao: '',
    acrescimo: '',
    desconto: '',
    tributo: null,
    ativo: null,
  };
  const navigate = useNavigate();
  const { state } = useLocation();
  const { postLoading, postGrid } = useContext(GridContext);
  const { control, handleSubmit, reset } = useForm({ defaultValues });

  useEffect(() => {
    reset(state?.values);
  }, []);

  const onSubmit = (data) =>
    postGrid({
      data: { data, rotina },
      cb: () => {
        navigate(-1);
        getDrops(['TabelaPreco']);
      },
    });

  return (
    <Container>
      <Header
        titulo={(Boolean(state) ? 'Editar' : 'Cadastrar') + ' Tabela de Preço'}
      />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input name="descricao" control={control} label="Descrição" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input name="acrescimo" control={control} label="Acréscimo" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input name="desconto" control={control} label="Desconto" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="tributo"
              control={control}
              label="Tributo"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Dropdown
              name="ativo"
              control={control}
              label="Ativo"
              options={dropBoolean}
            />
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Manutenção;
